import styled from "@emotion/styled";
import { Box } from "@kaltura/mediaspace-shared-styled";
import FormLabelWithDescription from "./../form/form-label-with-description/FormLabelWithDescription";
import { FormHelperText } from "@kaltura/ds-react-components";

export const StyledFormLabel = styled(FormLabelWithDescription)(({ theme }) => ({
    [`&`]: {
        marginBottom: theme.spacing(1),
    },
}));

export const StyledFormHelperText = styled(FormHelperText)(({ theme }) => ({
    marginTop: 0,
    marginBottom: theme.spacing(1),
}));

export const Container = styled(
    Box,
    {
        shouldForwardProp: (prop) => !["inline", "isHorizontal"].includes(prop),
    }
)<{ inline?: boolean; isHorizontal?: boolean }>(({ inline, isHorizontal, theme }) => ({
    display: "flex",
    flexDirection: isHorizontal ? "row" : "column",
    ...(
        !inline && {
            marginTop: theme.spacing(4),
        }
    ),
    ...(
        isHorizontal && {
            gap: theme.spacing(1),
            justifyContent: "space-between",
        }
    ),
    [theme.breakpoints.down(theme.breakpoints.values.sm)]: {
        display: "block",
        ...(
            isHorizontal && {
                display: "flex",
                gap: theme.spacing(1),
                justifyContent: "space-between",
            }
        ),
    },
}));
